<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
import Chart from "chart.js/dist/Chart.min.js";
export default {
  props: { data: Object, options: Object, type: String },
  data() {
    return { chart: null };
  },
  watch: {
    data: {
      handler(newData, oldData) {
        if (
          oldData.points &&
          newData.points.some((x, index) => oldData.points[index] !== x)
        ) {
          this.chart.data = {
            datasets: [
              {
                data: newData.points,
                backgroundColor: ["#3298dc", "#48c774", "#f14668", "#ffdd57"]
              }
            ],
            labels: newData.labels
          };
          this.chart.update();
        }
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.chart = new Chart(this.$refs.canvas.getContext("2d"), {
        type: "doughnut",

        data: {
          datasets: [
            {
              data: this.data.points,
              backgroundColor: ["#3298dc", "#48c774", "#f14668", "#ffdd57"]
            }
          ],
          labels: this.data.labels
        },

        options: this.options
      });
    });
  }
};
</script>
